import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostFailed, EGetPostActionType } from './types';

export const getPostFailed: () => TGetPostFailed = actionGenerator<EGetPostActionType.Failed>(
  EGetPostActionType.Failed,
);
